// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBar_wrapper__koCZX","logo":"SideBar_logo__0O8eC","menu-category":"SideBar_menu-category__L78cC","btn":"SideBar_btn__huYs7"};